module.exports = {
  "country": "RS",
  "artist": "Teya Dora",
  "song": "Ramonda",
  "year": "2024",
  "place": "17",
  "spotify": "3LDCaH8okEKDnLKEazmTDa"
};